import React from 'react';
import Loader from 'react-loaders';
import { Card, CardBody } from 'reactstrap';
import './index.css';

export type LoadingItemProps = { id: string; display: string; done?: boolean };

export type LoadingCardProps = { items: LoadingItemProps[] };

const LoadingItem = ({ done, display }: LoadingItemProps) => (
  <li className={done ? 'lp-done' : ''}>{display}</li>
);

const LoadingCard = ({ items }: LoadingCardProps) => {
  return (
    <Card>
      <CardBody className="d-flex flex-column flex-column">
        {items.length > 0 ? (
          <div className="d-flex flex-column align-items-center">
            <ul className="lp-list d-flex flex-column">
              {items.map(it => (
                <LoadingItem key={it.id} {...it} />
              ))}
            </ul>
          </div>
        ) : null}
        <div className="d-flex text-center h-100 mt-3 align-items-center">
          <div className="m-auto">
            <Loader
              active
              type="line-scale-pulse-out"
              innerClassName="m-auto"
            />
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
export default LoadingCard;
